import "../App.css";
import "../styles/login.css";
import { withRouter } from "react-router-dom";
import { useEffect, useState } from "react";
import Parametros from "../components/Parametros";
import CurrentUser from "./CurrentUser";
function GeoAdminLupa(props) {
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const id = props.geoAdmin;
  const [geoListState, setGeoListState] = useState({});
  useEffect(() => {
    let find = props.geoAdminList?.find((geo) => geo.geoadmin_zone_id === id);
    setGeoListState(find);
  }, [usuario, id, props.geoAdminList]);
  if (props.autocomplete) {
    return (
      <abbr className="verMasHover" style={{ position: "relative" }}>
        <div
          className="textHover"
          style={{ visibility: "hidden", top: "-3pc" }}
        >
          <div>
            {/* Código postal:{geoListState.zip_code}<br></br>
                    Coordenadas:{geoListState.coordinates}<br></br> */}
            Zona: {geoListState?.geoadmin1}/ Region: {geoListState?.geoadmin2}/
            Provincia: {geoListState?.geoadmin3}/ Cuidad:{" "}
            {geoListState?.geoadmin4}/ Comuna: {geoListState?.geoadmin5}/
            GeoAdmin 6: {geoListState?.geoadmin6}/ GeoAdmin 7:{" "}
            {geoListState?.geoadmin7}/ GeoAdmin 8: {geoListState?.geoadmin8}/
          </div>
        </div>
        <span
          style={{ cursor: "pointer" }}
          className="	glyphicon glyphicon-search"
        ></span>
      </abbr>
    );
  } else {
    return (
      <abbr className="verMasHover" style={{ position: "relative" }}>
        <div className="textHover" style={{ visibility: "hidden" }}>
          <div>
            {/* Código postal:{geoListState?.zip_code}<br></br>
                    Coordenadas:{geoListState?.coordinates}<br></br> */}
            Zona: {geoListState?.geoadmin1}
            <br></br>
            Region: {geoListState?.geoadmin2}
            <br></br>
            Provincia: {geoListState?.geoadmin3}
            <br></br>
            Cuidad: {geoListState?.geoadmin4}
            <br></br>
            Comuna: {geoListState?.geoadmin5}
            <br></br>
            GeoAdmin 6: {geoListState?.geoadmin6}
            <br></br>
            GeoAdmin 7: {geoListState?.geoadmin7}
            <br></br>
            GeoAdmin 8: {geoListState?.geoadmin8}
            <br></br>
          </div>
        </div>
        <span
          style={{ cursor: "pointer" }}
          className="	glyphicon glyphicon-search"
        ></span>
      </abbr>
    );
  }
}

export default withRouter(GeoAdminLupa);
